import { DragEvent, MouseEvent } from 'react';
import { batch, useDispatch } from 'react-redux';
import {
  DraggableNodeTypes,
  ExistingGraphNodeItem,
  RIGHT_RAIL_TABS,
  setActiveTab,
  setGrabbedItem,
  GraphNodeTypes,
  NewGraphNodeItem,
} from '../../../../services/ducks/designerDuck/designerDuck';
import { NODE_HEIGHT, NODE_WIDTH } from '../../../../utils/dimensions';

export function isGrabbedItemExisting(
  grabbedItem: ExistingGraphNodeItem | NewGraphNodeItem
): grabbedItem is ExistingGraphNodeItem {
  return grabbedItem.__type === 'existing';
}

export const getDragStartHandler =
  (
    dispatch: ReturnType<typeof useDispatch>,
    type: DraggableNodeTypes,
    grabbedItem: NewGraphNodeItem | ExistingGraphNodeItem
  ) =>
  (event: DragEvent<HTMLElement>) => {
    if (
      module ||
      type === GraphNodeTypes.STATE ||
      type === GraphNodeTypes.CHILD ||
      type === GraphNodeTypes.JUNCTION ||
      type === GraphNodeTypes.GROUP_JUNCTION
    ) {
      const draggedModule = document.querySelector('#DraggedModule');
      if (!draggedModule) return;
      batch(() => {
        dispatch(setGrabbedItem(grabbedItem));
      });

      const rect = event.currentTarget.getBoundingClientRect();
      const listItemGrabPositionX = event.clientX - rect.left; // x position within the element.
      const listItemWidth = rect.right - rect.left;
      const ratio = NODE_WIDTH / listItemWidth;

      event.dataTransfer.setDragImage(
        draggedModule,
        listItemGrabPositionX * ratio,
        NODE_HEIGHT / 2
      );
      document.body.classList.toggle('grabbing', true);
    }
  };

export const onDragHandler = (event: MouseEvent) => {
  event.preventDefault();
};

export const getDragEndHandler =
  (dispatch: ReturnType<typeof useDispatch>) => () => {
    batch(() => {
      dispatch(setGrabbedItem(undefined));
      dispatch(setActiveTab(RIGHT_RAIL_TABS.EDIT_MODULE));
    });
    document.body.classList.toggle('grabbing', false);
  };

export const generateFourDigitNumber = () =>
  Math.floor(1000 + Math.random() * 9000);
